import { create } from "zustand";

interface SelectedOrgState {
  selectedOrgId: number | null;
  setSelectedOrgId: (val: number | null) => void;
}

export const useSelectedOrgStore = create<SelectedOrgState>((set) => ({
  selectedOrgId: null,
  setSelectedOrgId: (val) => set({ selectedOrgId: val }),
}));
